import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import { jaJP } from '@mui/x-data-grid';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import Header from '../../components/Header';
import Frame from '../../components/uiParts/Frame';
import TitleBar from '../../components/uiParts/TitleBar';
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid';
import BidSearchForm from '../../components/uiParts/bid/BidSearchForm';
import { useAuth } from '../../contexts/AuthContext';
import { usePost } from './../../apis/ApiRequests';
import { dateToString } from '../../utils/Library';
import CustomCheckbox from '../../components/input/CustomCheckbox';
import CustomSnackBar from '../../components/alert/CustomSnackBar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { TableBody, TableCell, TableHead, TableRow, TablePagination, TableContainer, Table} from '@mui/material';
import { CustomTable } from '../../components/table/CustomTable';
import Paper from '@mui/material/Paper';
import KeyIcon from '@mui/icons-material/Key';
import LayersIcon from '@mui/icons-material/Layers';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';

const BidGroup = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
	// initialize - 基本情報を設定
	//-----------------------------------------------
	const { authInfo }    = useAuth();
	const facilityCode    = authInfo.facilityCode;
	const facilityName    = authInfo.facilityName;
	const userId          = authInfo.userId;
	const luserName       = authInfo.userName;
	const authority       = authInfo.authority;
    const today           = authInfo.targetDate;
	const authorityHeight = authority == 3 ? `${window.innerHeight - 220}px` : '220px';
	const navigate        = useNavigate();
    
    const search    = useLocation().search;
    const query     = new URLSearchParams(search);
    const checkStatus = Number(query.get("checkStatus") ?? 1);
    
    const title = authority == 3 ? '入札' : '入札';
    
	//-----------------------------------------------
	// initialize - useState
	//-----------------------------------------------
	const [ entryDate,           setEntryDate           ] = useState(today);
	const [ condition ,          setCondition           ] = useState('');
	const [ searchStatus ,       setSearchStatus        ] = useState(checkStatus);
	const [ searchCount,         setSearchCount         ] = useState(0);
	const [ bidList,             setBidList             ] = useState([]);
	const [ bidGroupList,        setBidGroupList        ] = useState([]);
	const [ dataGridHeight,      setDataGridHeight      ] = useState(window.innerHeight - 530);
	const [ checkedBidList,      setCheckedBidList      ] = useState([]);
	const [ bidGroupNo ,         setBidGroupNo          ] = useState('');
    const [ requireMessage,      setRequireMessage      ] = useState('');
    const [ registerData,        setRegisterData        ] = useState([]);
    const [ prevBidDate_1 ,      setPrevBidDate_1       ] = useState('');
    const [ prevBidDate_2 ,      setPrevBidDate_2       ] = useState('');
    const [ isLoading,           setIsLoading           ] = useState(false);
    const [ page,                setPage                ] = useState(() => Number(sessionStorage.getItem('page') || 0));
    const [ rowsPerPage,         setRowsPerPage         ] = useState(() => Number(sessionStorage.getItem('rowsPerPage') || 500));
    const [ selectedKey,         setSelectedKey         ] = useState(() => sessionStorage.getItem('selectedKey') || '');
    const [ isPreBid,            setIsPreBid            ] = useState(false); 
    const [ openDialogBundleBid, setOpenDialogBundleBid ] = useState(false); 
	const [ checkedBundleBid,    setCheckedBundleBid    ] = useState([]);
    const isBundleBidRef = useRef(false);
    const rowRefs = useRef({});

    // UI Message
    const [ messageState, setMessageState ] = useState({
        snackBarTrue      : false,
        snackBarFalse     : false,
        require           : false,
        confirm           : false,
        confirm_preBid    : false,
        confirm_BundleBid : false,
        confirm_CommonBid : false,
    });
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
	// API - searchData / BidGroup
	//-----------------------------------------------
	const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost();
	const searchData = async () => {
        const numericDate = dateToString(entryDate);
        const methodName = Number(authority) === 3 ? 'searchDataByTrader' : 'searchData';
        const postData = {
            'className'    : 'mch.models.table.BidGroup',
            'methodName'   : methodName,
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'keyword1'     : numericDate,
            'keyword2'     : condition,
            'keyword3'     : searchStatus
        }
        await searchData_post(postData);
	};
	//-----------------------------------------------
    // API - getGroupNo / BidGroup
	//-----------------------------------------------
    const { response : getNextNo_res, post : getNextNo_post } = usePost();
    const getNextNo = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidGroup',
            'methodName'   : 'getNextNo',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getNextNo_post(postData);
    };
	//-----------------------------------------------
    // API - setData / BidGroup
	//-----------------------------------------------
    const { response : setData_res, post:setData_post } = usePost();
    const setData = async (bidGroupNo) => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'       : 'mch.models.table.BidGroup',
            'methodName'      : 'setData',
            'facilityCode'    : facilityCode,
            'userId'          : userId,
            'activeFlag'      : 1,
            'userId'          : userId,
            'bidGroupNo'      : bidGroupNo,
            'entryDate'       : numericDate,
            'bidName'         : registerData.bidName,
            'kgSuryo'         : registerData.kgSuryo,
            'kgKubun'         : registerData.kgKubun,
            'suryo'           : registerData.suryo,
            'gyoshuCode'      : registerData.gyoshuCode,
            'nisugata'        : registerData.nisugata,
            'kikakuCode'      : registerData.kikakuCode,
            'methodCode'      : registerData.methodCode,
            'groupStatus'     : isPreBid ? 9 : 1,
            'uniqueId'        : registerData.uniqueId,
            'danbeNo'         : registerData.danbeNo,
            'danbe'           : registerData.danbe,
            'bidMode'         : registerData.bidMode,
        }
        await setData_post(postData);
    };
	//-----------------------------------------------
    // API - searchDataNoGroup / BidList
	//-----------------------------------------------
    const { response : searchData_bidList_res, loading : searchData_bidList_Loading, post:searchData_bidList_post } = usePost();
    const searchData_bidList = async () => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'searchDataNoGroup',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate
        }
        await searchData_bidList_post(postData);
    };
	//-----------------------------------------------
    // API - updateInBidGroup / BidList
	//-----------------------------------------------
    const { response : updateInBidGroup_res, post:updateInBidGroup_post } = usePost();
    const updateInBidGroup = async (bidGroupNo, bidData ,bidStatus=1) => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'updateInBidGroup',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : bidGroupNo,
            'entryDate'    : numericDate,
            'gyoshuCode'   : bidData.gyoshuCode,
            'nisugata'     : bidData.nisugata,
            'kikakuCode'   : bidData.kikakuCode,
            'kgKubun'      : bidData.kgKubun,
            'methodCode'   : bidData.methodCode,
            'bidMode'      : bidData.bidMode,
            'bidStatus'    : bidStatus,
            'danbeNo'      : bidData.danbeNo,
            'danbe'        : bidData.danbe,
            'bidMode'      : bidData.bidMode,
            'uniqueId'     : bidData.uniqueId,
        }
        await updateInBidGroup_post(postData);
    };
	//-----------------------------------------------
    // API - 過去入札日の参照
	//-----------------------------------------------
    const { response : getPrevBidDate_res, post:getPrevBidDate_post } = usePost();
    const getPrevBidDate = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'getPrevBidDate',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getPrevBidDate_post(postData);
    };
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        getPrevBidDate();
        setSearchCount(searchCount+1);
        const selectedKey = sessionStorage.getItem('selectedKey');
        if (selectedKey) {
            setSelectedKey(selectedKey);
            sessionStorage.removeItem('selectedKey');
        }
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 530);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
        
    },[]);
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData();
        searchData_bidList();
    }, [searchCount]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / BidGroup)
	//-----------------------------------------------
    useEffect(() => {
        setBidGroupList([]);
        if (searchData_res) {
            setBidGroupList(searchData_res.Data);
        }
    }, [searchData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextNo / BidGroup)
	//-----------------------------------------------
    useEffect(() => {
        if (getNextNo_res) {
            setBidGroupNo('');
            setBidGroupNo(getNextNo_res.bidGroupNo);
            setData(getNextNo_res.bidGroupNo);
            setMessageInfo('confirm', false);
            setMessageInfo('confirm_preBid', false);
            setMessageInfo('confirm_BundleBid', false);
            setMessageInfo('confirm_CommonBid', false);
            setMessageInfo('snackBarTrue', true);
            setIsLoading(false);
        }
    }, [getNextNo_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / BidGroup)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            checkedBidList.map(async (checkedBidListId) => {
                bidList.map(item => {
                    let bidData = {}
                    if (item.id == checkedBidListId) { 
                        bidData = item
                        updateInBidGroup(getNextNo_res.bidGroupNo, bidData);
                    }
                });
            });
            if (isBundleBidRef.current) {
                checkedBundleBid.map(async (checkedBundleBidId) => {
                    bidList.map(item => {
                        let bidData = {}
                        if (item.id == checkedBundleBidId) { 
                            bidData = item
                            updateInBidGroup(getNextNo_res.bidGroupNo, bidData);
                        }
                    });
                });
            }
        }
    }, [setData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchDataNoGroup / BidList)
	//-----------------------------------------------
    useEffect(() => {
        setBidList([]);
        if (searchData_bidList_res) {
            setBidList(searchData_bidList_res.Data);
        }
    }, [searchData_bidList_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(updateInBidGroup / BidList)
	//-----------------------------------------------
    useEffect(() => {
        if (updateInBidGroup_res) {
            setCheckedBidList([]);
            setCheckedBundleBid([]);
            setSearchCount(searchCount + 1);
        }
    }, [updateInBidGroup_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getPrevBidDate / bidList)
	//-----------------------------------------------
    useEffect(() => {
        setPrevBidDate_1('');
        setPrevBidDate_2('');
        if (getPrevBidDate_res) {
            setPrevBidDate_1(getPrevBidDate_res.prevDate1);
            setPrevBidDate_2(getPrevBidDate_res.prevDate2);
        }
    }, [getPrevBidDate_res]);
	//-----------------------------------------------
    // useEffect - 確定売り(bidPreRegister)へ遷移
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res && getNextNo_res?.bidGroupNo && isPreBid) {
            // 全件更新完了後に遷移
            navigate(`/bidPreRegister?bidGroupNo=${getNextNo_res.bidGroupNo}&checkStatus=${ searchStatus }`);
        }
    }, [setData_res, getNextNo_res, isPreBid]);
    //-----------------------------------------------
    // useEffect - 仲買人用 スクロール復元
	//-----------------------------------------------
    useEffect(() => {
        if (!selectedKey) return;
        let attempts = 0;
        const tryScroll = () => { // 描画待ちの行にスクロールを再試行
            const el = rowRefs.current[selectedKey];
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (attempts < 3) {
                attempts++;
                setTimeout(tryScroll, 100);
            }
        };
        tryScroll();
    }, [selectedKey]);
	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
        setEntryDate(value);
        setPage(0);
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - 検索ボタン
	//-----------------------------------------------
    const handleClick_search = () => {
        const requireStatus = checkedRequireBidDate(); // 必須項目をチェックする
        if (requireStatus) {
            setSearchCount(searchCount+1);
        } else {
            setMessageInfo('require', true);
        }
    };
	//-----------------------------------------------
    // eventHandler - 検索クリアボタン
	//-----------------------------------------------
    const handleClick_search_clear = () => {
        setEntryDate(today);
        setCondition('');
        setSearchStatus(1);
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
	// eventHandler - 検索Statusの変更
	//-----------------------------------------------
    const handleChange_searchStatus = (checked) => {
        const requireStatus = checkedRequireBidDate(); // 必須項目をチェックする
        if (requireStatus) {
            checked ? setSearchStatus(1) : setSearchStatus(0);
            setSearchCount(searchCount+1);
        } else {
            setMessageInfo('require', true);
        }
    };
	//-----------------------------------------------
	// eventHandler - 入札開始をクリック
	//-----------------------------------------------
    const handleClick_inBidGroup = async (preBidFlag = false) => {

        const requireStatus = checkedRequire(); // 必須項目をチェックする
        if (requireStatus) {
            isBundleBidRef.current = false;
            setCheckedBundleBid([]);
            setIsLoading(true);

            const bidFields = [];

            // 登録データのテンプレート
            const tempData = {
                'bidName'    : '',
                'kgSuryo'    : '',
                'kgKubun'    : '',
                'suryo'      : '',
                'gyoshuCode' : '',
                'nisugata'   : '',
                'kikakuCode' : '',
                'methodCode' : '',
                'bidMode'    : '',
                'danbeNo'    : '',
                'uniqueId'   : '',
            }
            let bidNameAll = '';
            let methodAll = '';
            let kgSuryoAll = 0;
            let suryoAll = 0;
            checkedBidList.map(async (checkedBidListId) => {
                
                let bidData = {};
                bidList.map(item => { if (item.id == checkedBidListId) { bidData = item } });
                
                if (!bidFields.includes(bidData.kikakuCode)) {
                    bidFields.push(`${bidData.kikakuCode}`);
                }
                kgSuryoAll = Number(kgSuryoAll) + Number(bidData.kgSuryo);
                suryoAll = Number(suryoAll) + Number(bidData.suryo);
                
                bidNameAll = bidData.bidName;
                if (bidData.method) {
                    methodAll = bidData.method;
                }
                tempData.kgKubun = bidData.kgKubun;
                tempData.gyoshuCode = bidData.gyoshuCode;
                tempData.nisugata = bidData.nisugata;
                tempData.kikakuCode = bidData.kikakuCode;
                tempData.methodCode = bidData.methodCode;
                tempData.bidMode = bidData.bidMode;
                tempData.danbeNo = bidData.danbeNo;
                tempData.danbe = bidData.danbe;
                tempData.uniqueId = bidData.uniqueId;
            });
            if (bidFields.length >= 2) {
                bidNameAll = `${ bidNameAll }（規格混合）`;
            }
            if (methodAll) {
                bidNameAll = `${ bidNameAll } / ${methodAll}`;
            }
            tempData.bidName = bidNameAll
            tempData.kgSuryo = kgSuryoAll.toFixed(2);
            tempData.suryo   = suryoAll !== Math.floor(suryoAll) ? suryoAll.toFixed(1) : suryoAll.toFixed(0);

            setRegisterData(tempData);
            
            // BidGroupを登録する
            if (bidFields.length) {
                await getNextNo(); // 新規の場合はbidGroupNoを発行して登録処理を実行
                setIsPreBid(preBidFlag); // 確定売り遷移フラグ
            }
        } else {
            setMessageInfo('require', true);
        }
        return false;
    };
	//-----------------------------------------------
	// eventHandler - 込み入札開始をクリック
	//-----------------------------------------------
    const handleClick_commonBid = async (preBidFlag = false) => {

            isBundleBidRef.current = false;
            setCheckedBundleBid([]);
            setIsLoading(true);

            const bidFields = [];

            // 登録データのテンプレート
            const tempData = {
                'bidName'    : '',
                'kgSuryo'    : '',
                'kgKubun'    : '',
                'suryo'      : '',
                'gyoshuCode' : '',
                'nisugata'   : '',
                'kikakuCode' : '',
                'methodCode' : '',
                'bidMode'    : '',
                'danbeNo'    : '',
                'uniqueId'   : '',
            }
            let bidNameAll = '';
            let methodAll = '';
            let kgSuryoAll = 0;
            let suryoAll = 0;
            checkedBidList.map(async (checkedBidListId) => {
                
                let bidData = {};
                bidList.map(item => { if (item.id == checkedBidListId) { bidData = item } });
                
                if (!bidFields.includes(bidData.kikakuCode)) {
                    bidFields.push(`${bidData.kikakuCode}`);
                }
                kgSuryoAll = Number(kgSuryoAll) + Number(bidData.kgSuryo);
                suryoAll = Number(suryoAll) + Number(bidData.suryo);
                
                bidNameAll = bidData.bidName;
                if (bidData.method) {
                    methodAll = bidData.method;
                }
                tempData.kgKubun = bidData.kgKubun;
                tempData.gyoshuCode = bidData.gyoshuCode;
                tempData.nisugata = bidData.nisugata;
                tempData.kikakuCode = bidData.kikakuCode;
                tempData.methodCode = bidData.methodCode;
                tempData.bidMode = bidData.bidMode;
                tempData.danbeNo = bidData.danbeNo;
                tempData.danbe = bidData.danbe;
                tempData.uniqueId = bidData.uniqueId;
            });
            if (bidFields.length >= 2) {
                bidNameAll = `${ bidNameAll }（込み）`;
            }
            if (methodAll) {
                bidNameAll = `${ bidNameAll } / ${methodAll}`;
            }
            tempData.bidName = bidNameAll
            tempData.kgSuryo = kgSuryoAll.toFixed(2);
            tempData.suryo   = suryoAll !== Math.floor(suryoAll) ? suryoAll.toFixed(1) : suryoAll.toFixed(0);

            setRegisterData(tempData);
            
            // BidGroupを登録する
            if (bidFields.length) {
                await getNextNo(); // 新規の場合はbidGroupNoを発行して登録処理を実行
                setIsPreBid(preBidFlag); // 確定売り遷移フラグ
            }
        return false;
    };
	//-----------------------------------------------
	// eventHandler - まとめ売りをクリック
	//-----------------------------------------------
    const handleClick_BundleBid = async () => {

        if (checkedBundleBid.length === 0) {
            setRequireMessage('セット魚種の選択が未選択です')
            setMessageInfo('require', true);   
            return false;
        };
        const requireStatus = checkedRequire(); // 必須項目をチェックする
        if (requireStatus) {
            isBundleBidRef.current = true;
            setIsLoading(true);

            // 登録データのテンプレート
            const tempData = {
                'bidName'    : '',
                'kgSuryo'    : '',
                'kgKubun'    : '',
                'suryo'      : '',
                'gyoshuCode' : '',
                'nisugata'   : '',
                'kikakuCode' : '',
                'methodCode' : '',
                'bidMode'    : '',
                'danbeNo'    : '',
                'danbe'      : '',
                'uniqueId'   : '',

            }
            let bidNameAll = '';

            let bidData = {};
            // 選択データ
            bidList.map(item => { if (item.id == checkedBidList) { bidData = item } });
            
            bidNameAll = `${ bidData.bidName } (まとめ) / ${bidData.method}` ;
            tempData.bidName = bidNameAll

            tempData.kgKubun = bidData.kgKubun;
            tempData.gyoshuCode = bidData.gyoshuCode;
            tempData.nisugata = bidData.nisugata;
            tempData.kikakuCode = bidData.kikakuCode;
            tempData.methodCode = bidData.methodCode;
            tempData.bidMode = bidData.bidMode;
            tempData.danbeNo = bidData.danbeNo;
            tempData.danbe = bidData.danbe;
            tempData.uniqueId = bidData.uniqueId;
            
            tempData.kgSuryo = Number(bidData.kgSuryo).toFixed(2);
            //tempData.suryo   = bidData.suryo !== Math.floor(bidData.suryo) ? bidData.suryo.toFixed(1) : bidData.suryo.toFixed(0);
            tempData.suryo = Number.isFinite(bidData.suryo)
            ? (bidData.suryo % 1 ? bidData.suryo.toFixed(1) : bidData.suryo.toFixed(0))
            : '';

            setRegisterData(tempData);
            
            // BidGroupを登録する
            await getNextNo(); // 新規の場合はbidGroupNoを発行して登録処理を実行
            
        } else {
            setMessageInfo('require', true);
        }
        setOpenDialogBundleBid(false);
        return false;
    };
    //-----------------------------------------------
	// eventHandler - 仲買人用 (table) 行をクリック
	//-----------------------------------------------
    const handleRowClick = (row) => {
        const uniqueKey =  row.bidGroupNo;
        const groupStatus = row.groupStatus;

        if (groupStatus != 9) {
            sessionStorage.setItem('page', page);
            sessionStorage.setItem('selectedKey', uniqueKey);
            //navigate('/bidRegister?bidGroupNo=' + uniqueKey);
            navigate(`/bidRegister?bidGroupNo=${uniqueKey}&checkStatus=${ searchStatus }`);
        } else {
            sessionStorage.setItem('page', page);
            sessionStorage.setItem('selectedKey', uniqueKey);
            //navigate('/bidManager?bidGroupNo=' + uniqueKey);
            navigate(`/bidManager?bidGroupNo=${uniqueKey}&checkStatus=${ searchStatus }`);
        }
    };
    //-----------------------------------------------
	// eventHandler - 仲買人用 (table) ページ遷移
	//-----------------------------------------------
    const handleChangePage = (_, newPage) => {
        setPage(newPage);
        sessionStorage.setItem('page', newPage);
    };
    const handleChangeRowsPerPage = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        sessionStorage.setItem('rowsPerPage', newRowsPerPage);
        sessionStorage.setItem('page', 0); 
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };
    //-----------------------------------------------
    // eventHandler - まとめ売り を表示
    //-----------------------------------------------
    const handleClick_dialog_BundleBid = () => {
        setCheckedBundleBid([]);
        if(checkedBidList.length !== 1) {
            setRequireMessage('まとめ売りできる入札は一件のみです')
            setMessageInfo('require', true);
            return;
            }
        setOpenDialogBundleBid(true);
    };
    //-----------------------------------------------
    // eventHandler - まとめ売り を非表示
    //-----------------------------------------------
    const handleClick_dialog_BundleBid_close = () => {
        setCheckedBundleBid([]);
        setOpenDialogBundleBid(false);
    };

	//===============================================
	// dataGrid
	//===============================================
	//-----------------------------------------------
    // dataGrid - 入札管理の見出し
	//-----------------------------------------------
    const columnsxBidGroup = [
        { field: 'entryNo',    headerName: 'No',   width: 80, columnSeparatorWidth: 1,sortable:false, },
        {
            field: 'groupStatus', headerName: 'ステータス', width: 90,sortable:false,
            renderCell: (params) => (
                <div style={{ 
                    color: params.value === 1 ? 'red' : 'inherit',
                    fontWeight: params.value === 1 ? 'normal' : 'normal'
                }}>
                    {params.row.groupStatusText}
                </div>
            ),
        },
        { field: 'startTime', headerName: '開始', width: 70, columnSeparatorWidth: 1,sortable:false, },
        { field: 'endTime', headerName: '終了', width: 70, columnSeparatorWidth: 1,sortable:false, },
        { field: 'bidName', headerName: '品名', width: 380, columnSeparatorWidth: 1,sortable:false, },
        { field: 'danbe', headerName: '水槽No', width: 90, columnSeparatorWidth: 1, sortable:false, },
        { field: 'kgSuryo', headerName: 'Kg数', width: 70, columnSeparatorWidth: 1, sortable:false, type:'number'},
        { field: 'suryo', headerName: '数量', width: 55, columnSeparatorWidth: 1, sortable:false, type:'number'},
        {
            field: 'kgKubun',
            headerName: '単位',
            sortable:false,
            width: 55,
            renderCell: (params) => (
              <div>
                {unitMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'bidPerson',    headerName: '登録者',     width: 120, columnSeparatorWidth: 1,sortable:false, },
    ];
    const authorityMapping = {
        0: '開始待ち',
        1: '入札中',
        8: '開票中',
        9: '入札終了'
    };
	//-----------------------------------------------
    // dataGrid - 未入札一覧の見出し
	//-----------------------------------------------
    const columnsxBidList = [
        { field: 'method',    headerName: '漁法',     width: 120, columnSeparatorWidth: 1, },
        { field: 'bidName', headerName: '品名', width: 410, columnSeparatorWidth: 1, sortable:false, },
        { field: 'danbe', headerName: '水槽No', width: 90, columnSeparatorWidth: 1, sortable:false, },
        { field: 'kgSuryo', headerName: 'Kg数', width: 80, columnSeparatorWidth: 1, sortable:false, type:'number'},
        { field: 'suryo', headerName: '数量', width: 55, columnSeparatorWidth: 1, sortable:false, type:'number'},
        {
            field: 'kgKubun',
            headerName: '単位',
            width: 55, sortable:false,
            renderCell: (params) => (
              <div>
                {unitMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'displayBiko',    headerName: '備考',     width: 200, columnSeparatorWidth: 1, },
    ];
    const unitMapping = {
        1: 'Kg',
        0: '箱',
        2: '本',
        3: '匹',
        4: '袋',
    };
	//-----------------------------------------------
    // dataGrid - まとめ売りの一覧の見出し
	//-----------------------------------------------
    const columnsxBundleBidList = [
        { field: 'method',    headerName: '漁法',     width: 100, columnSeparatorWidth: 1, },
        { field: 'bidName', headerName: '品名', width: 300, columnSeparatorWidth: 1, sortable:false, },
        { field: 'danbe', headerName: '水槽No', width: 90, columnSeparatorWidth: 1, sortable:false, },
        { field: 'kgSuryo', headerName: 'Kg数', width: 80, columnSeparatorWidth: 1, sortable:false, type:'number'},
        { field: 'suryo', headerName: '数量', width: 40, columnSeparatorWidth: 1, sortable:false, type:'number'},
        {
            field: 'kgKubun',
            headerName: '単位',
            width: 55, sortable:false,
            renderCell: (params) => (
              <div>
                {unitMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'displayBiko',    headerName: '備考',     width: 180, columnSeparatorWidth: 1, },
    ];
    //-----------------------------------------------
    // dataGrid - 入札一覧の行選択
    //-----------------------------------------------
    const handleClickxBidGroupList = (event) => {
        const uniqueKey = event.row.bidGroupNo;
        const groupStatus = event.row.groupStatus;
        
        if (authority == 3 && groupStatus != 9) {
            //navigate('/bidRegister?bidGroupNo=' + uniqueKey);
            navigate(`/bidRegister?bidGroupNo=${uniqueKey}&checkStatus=${ searchStatus }`);
        } else {
            //navigate('/bidManager?bidGroupNo=' + uniqueKey);
            navigate(`/bidManager?bidGroupNo=${uniqueKey}&checkStatus=${ searchStatus }`);
        }
    };
    //-----------------------------------------------
    // dataGrid - 未入札一覧の行選択
    //-----------------------------------------------
    const handleClickxBidList = (event) => {
        if (event.field === '__check__') {
            if (checkedBidList.includes(event.id)) {
                setCheckedBidList(checkedBidList.filter((checkedBidList, index) => (checkedBidList !== event.id)));
            } else {
                setCheckedBidList((checkedBidList)=>[...checkedBidList, event.id]);
            }
        }
    };
    //-----------------------------------------------
    // dataGrid - まとめ売りの行選択
    //-----------------------------------------------
    const handleClickxBundleBid = (event) => {
        if (event.field === '__check__') {
            if (checkedBundleBid.includes(event.id)) {
                setCheckedBundleBid(checkedBundleBid.filter((checkedBundleBid) => (checkedBundleBid !== event.id)));
            } else {
                setCheckedBundleBid((checkedBundleBid)=>[...checkedBundleBid, event.id]);
            }
        }
    };
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const errorFields = [];

        // bidListが1件以上ある場合のみ処理を行う
        const filteredBidList = bidList.filter(item => checkedBidList.includes(item.id));
        if (filteredBidList.length > 1) {

            // bidList内の最初の指定項目を取得
            const firstGyoshu    = filteredBidList[0].gyoshu;
            const firstNisugata = filteredBidList[0].nisugata;
            const firstMethod = filteredBidList[0].method;
            const firstDanbeNo = filteredBidList[0].danbeNo;

            // bidList内のすべての指定項目が一致しているかチェック
            const allGyoshuMatch    = filteredBidList.every(item => item.gyoshu === firstGyoshu);
            const allNisugataMatch = filteredBidList.every(item => item.nisugata === firstNisugata);
            const allMethodMatch = filteredBidList.every(item => item.method === firstMethod);
            const allDanbeNodMatch = filteredBidList.every(item => item.danbeNo === firstDanbeNo);

            if (!allGyoshuMatch) errorFields.push('「魚種」');
            if (!allNisugataMatch) errorFields.push('「荷姿」');
            if (!allMethodMatch) errorFields.push('「漁法」');
            if (!allDanbeNodMatch) errorFields.push('「水槽No」');
        }
    
        if (errorFields.length) {
            const text = errorFields.join('') + 'が同一のものを指定してください';
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        return true;  // エラーがない場合は true を返します
    };
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequireBidDate = () => {
        const errorFields = [];
        
        const numericEntryDate = dateToString(entryDate);
        
        if (authority == 3 && (numericEntryDate < prevBidDate_2)) errorFields.push('参照可能な入札日');
    
        if (errorFields.length) {
            const text = '過去の入札情報の参照は前回と前々回分まで可能です';
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        return true;  // エラーがない場合は true を返します
    };
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }));
    };
    //===============================================
    // Css
    //===============================================
    
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/home" setEntryDate={handleChange_entryDate} />
            <div className='bidGroup bodyContens'>
                <TitleBar title={title} />
                <div className='mainContents'>
                    <Frame classname="frame" title="入札検索">
                        <div style={{display:'flex'}}>
                            <div>
                            <BidSearchForm
                                targetDateId       = "bidGroup_targetDate"
                                targetDateValue    = { entryDate }
                                targetDateOnChange = { (e) => setEntryDate(e.target.value) }
                                keywordId          = "bidGroup_condition"
                                keywordValue       = { condition }
                                keywordOnChange    = { (e) => setCondition(e.target.value) }
                                handleSearch       = { () => handleClick_search() }
                                handleSearchClear  = { () => handleClick_search_clear() }
                            />
                            </div>
                            <div style={{marginLeft:'20px'}}>
                                <CustomCheckbox
                                    defaultChecked = { searchStatus }
                                    onChange       = { (e) => handleChange_searchStatus(e.target.checked) }
                                    label          = "入札未実施のみ"
                                />
                            </div>
                        </div>
                        <div style={{marginTop:'10px',display: authority == 3 ? 'none' : 'block'}}>
                            <CustomDataGrid
                                getRowClassName={(params) => {
                                    let className = ''
                                    if (params.indexRelativeToCurrentPage % 2 === 0) {
                                        className += 'even '
                                    } else {
                                        className += 'odd '
                                    }
                                    if (params.row.groupStatus === 1) {
                                        className += 'cell_inBidding'
                                    }
                                    return className.trim() // クラス名の文字列の前後の余分な空白を削除
                                }}
                                editMode                = "row"
                                disableSelectionOnClick = { true } 
                                rows                    = { bidGroupList }
                                columns                 = { columnsxBidGroup }
                                sx                      = { {height:authorityHeight,fontSize:14,borderColor: 'primary.light',} }
                                density                 = "compact"
                                localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                showColumnRightBorder
                                showCellRightBorder
                                disableColumnMenu       = {true}
                                onCellClick             = {(event) => handleClickxBidGroupList(event)}
                                loading                 = { searchData_bidList_Loading }
                            />
                        </div>
                        <div style={{ marginTop: '10px', display: authority == 3 ? 'block' : 'none' }}>
                            <TableContainer component={Paper}
                                style={{
                                    border: '1px solid',
                                    minHeight: authorityHeight,
                                    maxHeight: authorityHeight,
                                    maxWidth: "100%",
                                    overflow: 'auto',
                                    msOverflowStyle: 'none',
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    backgroundColor: '#d3d3d3'
                                }}>
                                <CustomTable
                                    stickyHeader
                                    aria-label="sticky table"
                                    size="small"
                                    sx={{ whiteSpace: 'nowrap'}}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ width: 80 }}>No</TableCell>
                                            <TableCell style={{ width: 90 }}>ステータス</TableCell>
                                            <TableCell style={{ width: 70 }}>開始</TableCell>
                                            <TableCell style={{ width: 70 }}>終了</TableCell>
                                            <TableCell style={{ width: 380 }}>品名</TableCell>
                                            <TableCell style={{ width: 80 }}>水槽No</TableCell>
                                            <TableCell style={{ width: 70 }}>Kg数</TableCell>
                                            <TableCell style={{ width: 55 }}>数量</TableCell>
                                            <TableCell style={{ width: 55 }}>単位</TableCell>
                                            <TableCell style={{ width: 120 }}>登録者</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {bidGroupList
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, index) => (
                                                <TableRow
                                                    hover
                                                    sx={{
                                                        '&:hover': {
                                                            backgroundColor: '#ffe4e1 !important', // ホバー時の背景色
                                                        },
                                                    }}
                                                    key={row.bidGroupNo}
                                                    className={[
                                                    index % 2 === 0 ? 'even' : 'odd',
                                                    row.groupStatus === 8 || row.groupStatus === 9 // 開票中、入札終了
                                                      ? ''
                                                      : row.isBidding === 1                        // 入札済み
                                                        ? 'cell_bidDone'
                                                        : row.groupStatus === 1                    // 入札中
                                                          ? 'cell_inBidding'
                                                          : ''
                                                    ].join(' ').trim()}
                                                    ref={(el) => (rowRefs.current[row.bidGroupNo] = el)}
                                                    selected={row.bidGroupNo === bidGroupNo}
                                                    onClick={() => handleRowClick(row)}
                                                >
                                                    <TableCell align="right" >{row.entryNo}</TableCell>
                                                    <TableCell>
                                                        <div
                                                            style={{
                                                                color: row.authority === 1 ? 'red' : 'inherit',
                                                                fontWeight: row.authority === 1 ? 'normal' : 'normal',
                                                            }}
                                                        >
                                                              {row.groupStatus === 8 || row.groupStatus === 9
                                                              ? authorityMapping[row.groupStatus]
                                                                : row.isBidding === 1
                                                                ? '入札済み'
                                                                  : authorityMapping[row.groupStatus] || row.kgKubun}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>{row.startTime}</TableCell>
                                                    <TableCell>{row.endTime}</TableCell>
                                                    <TableCell>{row.bidName}</TableCell>
                                                    <TableCell>{row.danbe}</TableCell>
                                                    <TableCell align="right" >{row.kgSuryo}</TableCell>
                                                    <TableCell align="right" >{row.suryo}</TableCell>
                                                    <TableCell>
                                                        {unitMapping[row.kgKubun] || row.kgKubun}
                                                    </TableCell>
                                                    <TableCell>{row.bidPerson}</TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </CustomTable>
                                <div
                                    style={{
                                        position: 'sticky',
                                        left: 0,
                                        bottom: 0,
                                        backgroundColor: '#d3d3d3',
                                        border: '1px solid rgb(225, 225, 225)',
                                        zIndex: 1,
                                    }}
                                >
                                    <TablePagination
                                        component="div"
                                        count={bidGroupList.length}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        labelRowsPerPage='ページあたりの行数:'
                                        rowsPerPageOptions={[100, 250, 500]}
                                    />
                                </div>
                            </TableContainer>
                        </div>
                    </Frame>
                    <div style={{ display: authority == 3 ? 'none' : 'block' }}>
                        <Frame classname="frame" title="未入札一覧">
                            <div style={{display:'flex'}}>
                                <div style={{marginBottom:'8px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff', backgroundColor:'#ff0000'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<ArrowCircleUpIcon />}
                                        onClick   = {() => setMessageInfo('confirm', true) }
                                    >
                                    入札開始
                                    </Button>
                                </div>
                                <div style={{marginBottom:'8px', marginLeft:'10px'}}>
                                    <Button
                                        color     = "primary"
                                        style     = {{color:'#fff', }}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<KeyIcon />}
                                        onClick   = {() => setMessageInfo('confirm_preBid', true) }
                                    >
                                    確定売り
                                    </Button>
                                </div>
                                <div style={{marginBottom:'8px', marginLeft:'10px'}}>
                                    <Button
                                        color     = "primary"
                                        style     = {{color:'#fff', }}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<LayersIcon />}
                                        onClick   = {() => handleClick_dialog_BundleBid() }
                                    >
                                    まとめ売り
                                    </Button>
                                </div>
                                <div style={{marginBottom:'8px', marginLeft:'10px'}}>
                                    <Button
                                        color     = "primary"
                                        style     = {{color:'#fff', }}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<DynamicFeedIcon />}
                                        onClick   = {() => setMessageInfo('confirm_CommonBid', true) }
                                    >
                                    込み入札
                                    </Button>
                                </div>
                            </div>
                            <CustomDataGrid
                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                }
                                editMode                = "row"
                                disableSelectionOnClick = { true } 
                                rows                    = { bidList }
                                columns                 = { columnsxBidList }
                                sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                                density                 = "compact"
                                localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                showColumnRightBorder
                                showCellRightBorder
                                checkboxSelection
                                disableColumnMenu          = {true}
                                onCellClick                = {(event) => handleClickxBidList(event)}
                                onRowSelectionModelChange  = {(newSelectionModel) => { setCheckedBidList(newSelectionModel) }}
                                rowSelectionModel          = {checkedBidList}
                                loading                    = { searchData_Loading }
                            />
                        </Frame>
                    </div>
                </div>
                <div className='dialog_BundleBid'>
                    <Dialog open={ openDialogBundleBid } onClose={ handleClick_dialog_BundleBid_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="セット魚種の選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            <CustomDataGrid
                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                }
                                editMode                = "row"
                                disableSelectionOnClick = { true } 
                                rows                    = { bidList.filter((_, index) => !checkedBidList.includes(index + 1)) } //選択以外を表示
                                columns                 = { columnsxBundleBidList }
                                sx                      = { {height: "100%",fontSize:14,borderColor: 'primary.light',} }
                                density                 = "compact"
                                localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                showColumnRightBorder
                                showCellRightBorder
                                checkboxSelection
                                disableColumnMenu          = {true}
                                onCellClick                = {(event) => handleClickxBundleBid(event)}
                                onRowSelectionModelChange  = {(newSelectionModel) => { setCheckedBundleBid(newSelectionModel) }} 
                                rowSelectionModel          = { checkedBundleBid }
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = {{ color:'#fff', width:'400px',  marginRight:'5%', marginBottom:'2%' , marginLeft: '5%', backgroundColor:'#808080'}} //</DialogActions>dialog_button_close
                                onClick   = {() => handleClick_dialog_BundleBid_close()}

                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                            <Button
                                color   = "tertiary"
                                size    = "large"
                                variant = "contained"
                                sx      = {{ color:'#fff', width:'400px', backgroundColor:'#ff0000'
                                    , marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => setMessageInfo('confirm_BundleBid', true)} 
                                startIcon = {<CheckIcon />}
                               
                            >入札開始
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "入札を開始しました"
                />
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <div>
                    <Dialog open={messageState.confirm} onClose={() => setMessageInfo('confirm', false)}>
                        <DialogContent>
                            <DialogContentText>
                            入札を開始します。よろしいですか？
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setMessageInfo('confirm', false)} color="primary">キャンセル</Button>
                            <Button onClick={() => handleClick_inBidGroup()} color="primary" disabled={isLoading}>続行</Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div>
                    <Dialog open={messageState.confirm_preBid} onClose={() => setMessageInfo('confirm_preBid', false)}>
                        <DialogContent>
                            <DialogContentText>
                            確定売りにします。よろしいですか？
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setMessageInfo('confirm_preBid', false)} color="primary">キャンセル</Button>
                            <Button onClick={() => handleClick_inBidGroup(true)} color="primary" disabled={isLoading}>続行</Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div>
                    <Dialog open={messageState.confirm_BundleBid} onClose={() => setMessageInfo('confirm_BundleBid', false)}>
                        <DialogContent>
                            <DialogContentText>
                            まとめ売りにします。よろしいですか？
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setMessageInfo('confirm_BundleBid', false)} color="primary">キャンセル</Button>
                            <Button onClick={() => handleClick_BundleBid()} color="primary" disabled={isLoading}>続行</Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div>
                    <Dialog open={messageState.confirm_CommonBid} onClose={() => setMessageInfo('confirm_CommonBid', false)}>
                        <DialogContent>
                            <DialogContentText>
                            込み入札を開始します。よろしいですか？
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setMessageInfo('confirm_CommonBid', false)} color="primary">キャンセル</Button>
                            <Button onClick={() => handleClick_commonBid()} color="primary" disabled={isLoading}>続行</Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        </>
    )
}
export default BidGroup;